import type { UseInfiniteQueryResult } from "@tanstack/react-query";

export const getPaginatedInfiniteQueryData = <TOutput>(query: UseInfiniteQueryResult<server.dto.ApiResponseWrapper<TOutput[]>>) => 
  query.data?.pages.flatMap(p => p.data ?? []) ?? [];
